import type { ScheduledCopyOverrides } from './scheduled-page-copy-types';

export const scheduledPageCopyOverridesWestern = {
  'pt-BR': {
    common: {
      close: 'Fechar',
      cancel: 'Cancelar',
      save: 'Salvar alterações',
      create: 'Criar agendamento',
      edit: 'Editar',
      retry: 'Tentar novamente',
      back: 'Voltar',
      next: 'Continuar',
      loading: 'Carregando',
      view: 'Ver',
      unknown: 'Desconhecido',
      notAvailable: 'Não disponível',
    },
    header: {
      navLabel: 'Agendamentos',
      title: 'Agendamentos',
      subtitle: 'Tarefas do agente executadas automaticamente no seu horário.',
      timezone: 'Horários exibidos em {timezone}',
      searchPlaceholder: 'Pesquisar agendamentos',
      newSchedule: 'Novo agendamento',
      create: 'Criar',
      createWithAgent: 'Criar com o agente',
      setUpManually: 'Configurar manualmente',
      createWithAgentPrompt:
        'Ajude-me a configurar uma tarefa agendada. Explique como funciona, pergunte o que preciso e quando, e mostre uma prévia para confirmação.',
    },
    filters: {
      all: 'Todos',
      mine: 'Meus',
      shared: 'Compartilhados',
      archived: 'Arquivados',
      filters: 'Filtros',
      moreScopes: 'Mais visualizações de agendamentos',
      status: 'Situação',
      anyStatus: 'Qualquer status',
      active: 'Ativos',
      paused: 'Pausados',
      completed: 'Concluídos',
    },
    calendar: {
      label: 'Calendário de agentes agendados',
      emptyTitle: 'Planeje sua próxima tarefa agendada',
      more: 'mais {count}',
      truncated:
        'Este período tem mais resultados. Reduza as datas ou os filtros para ver tudo.',
      offlineTitle: 'Você está offline',
      offlineDescription:
        'Reconecte-se para carregar os agendamentos e fazer alterações.',
      malformed: 'Este agendamento não pôde ser exibido com segurança.',
      loading: 'Carregando calendário',
      allDay: 'Linha do tempo do agendamento',
    },
    detail: {
      sourceManual: 'Criado manualmente',
    },
  },
  de: {
    header: {
      navLabel: 'Geplant',
      title: 'Geplant',
      subtitle: 'Agentenaufgaben, die unbeaufsichtigt zu deiner Zeit laufen.',
      searchPlaceholder: 'Zeitpläne suchen',
      newSchedule: 'Neuer Zeitplan',
      create: 'Erstellen',
      createWithAgent: 'Mit Agent erstellen',
      setUpManually: 'Manuell einrichten',
      createWithAgentPrompt:
        'Hilf mir, eine geplante Aufgabe einzurichten. Erkläre kurz, wie sie funktioniert, und frage dann, was ich wann brauche. Zeige mir zur Bestätigung eine Vorschau.',
      timezone: 'Zeiten in {timezone}',
    },
    filters: {
      all: 'Alle',
      mine: 'Meine',
      shared: 'Geteilt',
      archived: 'Archiviert',
      filters: 'Filter',
      moreScopes: 'Weitere Zeitplanansichten',
      status: 'Zeitplanstatus',
      anyStatus: 'Jeder Status',
      active: 'Aktiv',
      paused: 'Pausiert',
      completed: 'Abgeschlossen',
    },
    calendar: {
      label: 'Kalender für geplante Agentenaufgaben',
      emptyTitle: 'Plane deine nächste geplante Aufgabe',
      more: '{count} weitere',
      truncated:
        'Dieser Zeitraum enthält weitere Ergebnisse. Grenze Datum oder Filter ein, um alles zu sehen.',
      offlineTitle: 'Du bist offline',
      offlineDescription:
        'Stelle die Verbindung wieder her, um Zeitpläne zu laden und Änderungen vorzunehmen.',
      malformed: 'Dieser Zeitplan konnte nicht sicher angezeigt werden.',
      loading: 'Kalender wird geladen',
      allDay: 'Zeitplan-Zeitleiste',
    },
    common: {
      close: 'Schließen',
      cancel: 'Abbrechen',
      save: 'Änderungen speichern',
      create: 'Zeitplan erstellen',
      edit: 'Bearbeiten',
      retry: 'Erneut versuchen',
      back: 'Zurück',
      next: 'Weiter',
      loading: 'Wird geladen',
      view: 'Ansehen',
      unknown: 'Unbekannt',
      notAvailable: 'Nicht verfügbar',
    },
  },
  es: {
    header: {
      navLabel: 'Programado',
      title: 'Programado',
      subtitle: 'Tareas del agente que se ejecutan sin supervisión a tu hora.',
      searchPlaceholder: 'Buscar programaciones',
      newSchedule: 'Nueva programación',
      create: 'Crear',
      createWithAgent: 'Crear con el agente',
      setUpManually: 'Configurar manualmente',
      createWithAgentPrompt:
        'Ayúdame a configurar una tarea programada. Explica cómo funciona y pregúntame qué necesito y cuándo. Muéstrame una vista previa para confirmarla.',
      timezone: 'Horas mostradas en {timezone}',
    },
    filters: {
      all: 'Todo',
      mine: 'Mío',
      shared: 'Compartido',
      archived: 'Archivado',
      filters: 'Filtros',
      moreScopes: 'Más vistas de programación',
      status: 'Estado',
      anyStatus: 'Cualquier estado',
      active: 'Activo',
      paused: 'En pausa',
      completed: 'Completado',
    },
    calendar: {
      label: 'Calendario de tareas programadas del agente',
      emptyTitle: 'Planifica tu próxima tarea programada',
      more: '{count} más',
      truncated:
        'Este intervalo tiene más resultados. Reduce las fechas o los filtros para verlos todos.',
      offlineTitle: 'Sin conexión',
      offlineDescription:
        'Vuelve a conectarte para cargar programaciones y hacer cambios.',
      malformed: 'Esta programación no se pudo mostrar de forma segura.',
      loading: 'Cargando calendario',
      allDay: 'Cronología de programaciones',
    },
    common: {
      close: 'Cerrar',
      cancel: 'Cancelar',
      save: 'Guardar cambios',
      create: 'Crear programación',
      edit: 'Editar',
      retry: 'Reintentar',
      back: 'Atrás',
      next: 'Continuar',
      loading: 'Cargando',
      view: 'Ver',
      unknown: 'Desconocido',
      notAvailable: 'No disponible',
    },
  },
  fr: {
    header: {
      navLabel: 'Planifié',
      title: 'Planifié',
      subtitle: 'Tâches d’agent exécutées sans surveillance à votre heure.',
      searchPlaceholder: 'Rechercher des planifications',
      newSchedule: 'Nouvelle planification',
      create: 'Créer',
      createWithAgent: 'Créer avec l’agent',
      setUpManually: 'Configurer manuellement',
      createWithAgentPrompt:
        'Aide-moi à configurer une tâche planifiée. Explique son fonctionnement, puis demande-moi ce qu’il faut faire et quand. Montre-moi un aperçu pour confirmation.',
      timezone: 'Heures affichées en {timezone}',
    },
    filters: {
      all: 'Tout',
      mine: 'Les miens',
      shared: 'Partagés',
      archived: 'Archivés',
      filters: 'Filtres',
      moreScopes: 'Autres vues de planification',
      status: 'État',
      anyStatus: 'Tous les états',
      active: 'Actif',
      paused: 'En pause',
      completed: 'Terminé',
    },
    calendar: {
      label: 'Calendrier des tâches d’agent planifiées',
      emptyTitle: 'Planifiez votre prochaine tâche programmée',
      more: '{count} de plus',
      truncated:
        'Cette période contient davantage de résultats. Réduisez les dates ou les filtres pour tout afficher.',
      offlineTitle: 'Vous êtes hors ligne',
      offlineDescription:
        'Reconnectez-vous pour charger les planifications et les modifier.',
      malformed:
        'Cette planification n’a pas pu être affichée en toute sécurité.',
      loading: 'Chargement du calendrier',
      allDay: 'Chronologie des planifications',
    },
    common: {
      close: 'Fermer',
      cancel: 'Annuler',
      save: 'Enregistrer',
      create: 'Créer la planification',
      edit: 'Modifier',
      retry: 'Réessayer',
      back: 'Retour',
      next: 'Continuer',
      loading: 'Chargement',
      view: 'Voir',
      unknown: 'Inconnu',
      notAvailable: 'Indisponible',
    },
  },
  it: {
    header: {
      navLabel: 'Programmati',
      title: 'Programmati',
      subtitle: 'Attività agente eseguite senza supervisione al tuo orario.',
      searchPlaceholder: 'Cerca pianificazioni',
      newSchedule: 'Nuova pianificazione',
      create: 'Crea',
      createWithAgent: 'Crea con l’agente',
      setUpManually: 'Configura manualmente',
      createWithAgentPrompt:
        'Aiutami a configurare un’attività pianificata. Spiega come funziona, poi chiedimi cosa mi serve e quando. Mostrami un’anteprima per conferma.',
      timezone: 'Orari mostrati in {timezone}',
    },
    filters: {
      all: 'Tutti',
      mine: 'Miei',
      shared: 'Condivisi',
      archived: 'Archiviati',
      filters: 'Filtri',
      moreScopes: 'Altre viste di pianificazione',
      status: 'Stato',
      anyStatus: 'Qualsiasi stato',
      active: 'Attivo',
      paused: 'In pausa',
      completed: 'Completato',
    },
    calendar: {
      label: 'Calendario delle attività agente programmate',
      emptyTitle: 'Pianifica la tua prossima attività programmata',
      more: 'Altri {count}',
      truncated:
        'Questo intervallo contiene altri risultati. Restringi le date o i filtri per vederli tutti.',
      offlineTitle: 'Sei offline',
      offlineDescription:
        'Riconnettiti per caricare le pianificazioni e apportare modifiche.',
      malformed:
        'Questa pianificazione non può essere visualizzata in sicurezza.',
      loading: 'Caricamento del calendario',
      allDay: 'Cronologia delle pianificazioni',
    },
    common: {
      close: 'Chiudi',
      cancel: 'Annulla',
      save: 'Salva modifiche',
      create: 'Crea pianificazione',
      edit: 'Modifica',
      retry: 'Riprova',
      back: 'Indietro',
      next: 'Continua',
      loading: 'Caricamento',
      view: 'Visualizza',
      unknown: 'Sconosciuto',
      notAvailable: 'Non disponibile',
    },
  },
} satisfies ScheduledCopyOverrides;
